"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#00a2ff",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#fff",
    d: "m17.836 10.16-3.71-.672a.22.22 0 0 1-.153-.11l-1.801-3.275a.22.22 0 0 0-.372 0L10.022 9.39a.22.22 0 0 1-.152.11l-3.706.692a.203.203 0 0 0-.106.34L8.763 13.3a.22.22 0 0 1 .059.186L8.216 17.2a.203.203 0 0 0 .286.21l3.42-1.637a.22.22 0 0 1 .187 0l3.43 1.618a.2.2 0 0 0 .284-.214l-.352-2.08-.119-.714a4.1 4.1 0 0 0 .9-.818.12.12 0 0 0 .012-.113 15.5 15.5 0 0 1-6.03.971 7 7 0 0 1-.866-.08.205.205 0 0 1-.112-.36c.786-.655 3.4-2.545 3.44-2.576a.08.08 0 0 0 .032-.064.08.08 0 0 0-.032-.065c-.06-.05-1.496-.552-3.688-.211a.14.14 0 0 1-.154-.187.14.14 0 0 1 .062-.072 8.3 8.3 0 0 1 3.459-.729 4.25 4.25 0 0 1 2.114.491c.127.095.101.212 0 .3-.537.459-2.065 1.525-2.6 1.936a.083.083 0 0 0-.012.126q.018.018.041.023a10.5 10.5 0 0 0 3.262.456l2.76-2.898a.204.204 0 0 0-.11-.339"
  })]
}), 'Qzone');
//# sourceMappingURL=index.js.map